import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import dragula from 'react-dragula';

import Switch from '@material-ui/core/Switch';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { EditIcon, TrashIcon, AddIcon } from '../../../../images/icons/WrapSvg';

let scrollable = true;
let listener = function(e) {
    if (!scrollable) {
        e.preventDefault();
    }
};

function searchTree(elements, id) {
    let i;
    let result = null;
    if (id === 'root') {
        return elements;
    } else {
        for (i = 0; result === null && i < elements.length; i++) {
            if (elements[i].id === id) {
                result = elements[i].hijos;
            }
            if (result === null && elements[i].hijos) result = searchTree(elements[i].hijos, id);
        }
        return result;
    }
}

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    if (startIndex < endIndex) endIndex = endIndex - 1;
    list.splice(endIndex, 0, removed);
    return list;
};

class Export extends React.Component {
    state = {
        data: this.props.info,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ data: nextProps.info });
    }

    handleChecked = (event) => {
        this.props.onCron(event.target.name, event.target.checked);
    };

    element = (element, parent) => {
        return (
            <div className={'span'}>
                <div className={'flex_full_row align_center hand'}>
                    {element.ocultar ? (
                        <ExpandLess
                            className="hand c_white"
                            onClick={() => this.props.onShow(element.id, false)}
                        />
                    ) : (
                        <ExpandMore
                            className="hand c_white"
                            onClick={() => this.props.onShow(element.id, true)}
                        />
                    )}
                    <div className={'flex_full_row barlow_regular_smalltext'}>{element.nombre}</div>
                    <AddIcon
                        className={'c_bluish'}
                        onClick={() => this.props.onAdd('new', element.id)}
                    />
                    <Switch
                        name={element.id.toString()}
                        checked={element.evitarCron}
                        onChange={this.handleChecked}
                        value="evitarCron"
                        color="primary"
                    />
                    <EditIcon
                        className={'margin_left_12 c_bluish'}
                        onClick={() => this.props.onEdit(element.id, parent)}
                    />
                    <TrashIcon
                        className={'margin_left_12 c_lipstick'}
                        onClick={() => this.props.onDelete(element.id, parent)}
                    />
                </div>
            </div>
        );
    };

    subTree = (element, parent) => {
        if (element && element.id) {
            return (
                <div id={element.id} key={`node2-${element.id}`} className="bloc--first li">
                    <div id={element.id} className="bloc--inner">
                        {this.element(element, parent)}
                        {!element.ocultar && (
                            <div id={element.id} className={'bloc ul dottedBox'}>
                                {element.hijos &&
                                    element.hijos.length > 0 &&
                                    element.hijos.map((c) => this.subTree(c, element.id))}
                            </div>
                        )}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    UNSAFE_componentWillMount() {
        document.addEventListener('touchmove', listener, { passive: false });

        this.drake = dragula([document.querySelector('.container')], {
            moves: function(el, container, handle) {
                return handle.classList.contains('draggable');
            },
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });

        this.drake = dragula([].slice.apply(document.querySelectorAll('.bloc')), {
            direction: 'horizontal',
        });
        this.drake.on('drop', this.drop.bind(this));
        this.drake.on('drag', function(el, source) {
            scrollable = false;
        });
        this.drake.on('dragend', function(el, source) {
            scrollable = true;
        });
    }

    componentDidUpdate() {
        this.drake.containers = [].slice.apply(document.querySelectorAll('.bloc'));
    }

    drop = (el, target, source, sibling) => {
        scrollable = true;
        this.drake.cancel(true);

        const elementId = parseInt(el.id, 10);
        try {
            if (target.id === source.id) {
                const arr = [...this.state.data];
                let list = searchTree(
                    arr,
                    target.id === 'root' ? target.id : parseInt(target.id, 10),
                );
                if (list) {
                    const codes = list.map((f) => f.id);
                    const source = codes.indexOf(elementId);
                    const destination =
                        sibling === null ? list.length : codes.indexOf(parseInt(sibling.id, 10));
                    list = reorder(list, source, destination);
                    this.props.onDrop(arr);
                }
            } else {
                const arr = [...this.state.data];
                let origen = searchTree(
                    arr,
                    source.id === 'root' ? source.id : parseInt(source.id, 10),
                );
                if (origen) {
                    const sourceIndex = origen.map((f) => f.id).indexOf(elementId);
                    const [removed] = origen.splice(sourceIndex, 1);
                    let destination = searchTree(
                        arr,
                        target.id === 'root' ? target.id : parseInt(target.id, 10),
                    );
                    if (destination) {
                        const destinationIndex =
                            sibling === null
                                ? destination.length
                                : destination.map((f) => f.id).indexOf(parseInt(sibling.id, 10));
                        destination.splice(destinationIndex, 0, removed);
                        this.props.onDrop(arr);
                    }
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    render() {
        const { data } = this.state;
        return (
            <div className="flex_full_column margin_top_32 ">
                <div className="flex_full_row">
                    <div className="flex_full_row c_dark_grey_blue barlow_semibold">
                        <FormattedMessage id="form_field_name_structure" />
                    </div>
                </div>
                <div className="flex_full_column margin_top_24 padding_borders_equals">
                    <div
                        className={
                            'span flex_full_row  bg_slate_grey c_white padding_borders_equals'
                        }
                    >
                        <div className={'draggable flex_full_row align_center hand'}>
                            <div className={'flex_full_row barlow_regular_smalltext'}>
                                <FormattedMessage id="locals_menu" />
                            </div>
                            <AddIcon
                                className={'c_bluish'}
                                onClick={() => this.props.onAdd('new', 'root')}
                            />
                        </div>
                    </div>
                    <div className="container customer-tree ">
                        <div id={'root'} className={'bloc ul dottedBox'}>
                            {data &&
                                data.length > 0 &&
                                data.map((child) => (
                                    <div
                                        key={`node-${child.id}`}
                                        id={child.id}
                                        className="bloc--first li"
                                    >
                                        <div id={child.id} className="bloc--inner">
                                            {this.element(child, 'root')}
                                            {!child.ocultar && (
                                                <div id={child.id} className={'bloc ul dottedBox'}>
                                                    {child.hijos.map((c) =>
                                                        this.subTree(c, child.id),
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Export;



// WEBPACK FOOTER //
// ./src/components/complex/manage/customer/Tree.js